module.exports = __webpack_public_path__ + "static/media/DevTools.1827a04e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/DevTools.svg
// module id = 244
// module chunks = 0